import {
  twind_config_default
} from "./chunk.CXWFHCTO.js";
import {
  base
} from "./chunk.QKLA5QHC.js";

// src/assets/scripts/JbIntElement.ts
import install from "@twind/with-web-components";
import { LitElement } from "lit";
function WithTwind(superClass) {
  return install(twind_config_default, false)(superClass);
}
function WithBaseStyles(superClass) {
  class WithBaseStylesMixin extends superClass {
    static {
      this.styles = [base];
    }
  }
  return WithBaseStylesMixin;
}
function WithCustomEvents(superClass) {
  class WithCustomEventsClass extends superClass {
    emit(e) {
      return this.dispatchEvent(new CustomEvent(e.type, { detail: e.detail, bubbles: true, composed: true }));
    }
  }
  return WithCustomEventsClass;
}
var JbIntElementInit = () => WithCustomEvents(WithBaseStyles(WithTwind(LitElement)));
var JbIntElementInitWithouthTwind = () => WithCustomEvents(WithBaseStyles(LitElement));

export {
  WithTwind,
  WithBaseStyles,
  WithCustomEvents,
  JbIntElementInit,
  JbIntElementInitWithouthTwind
};
